import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-passport-info',
  templateUrl: './passport-info.component.html',
  styleUrls: ['./passport-info.component.scss']
})
export class PassportInfoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
